import React, { useState, TextareaHTMLAttributes } from 'react';
import './text-area.styles.scss';

interface IProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    name: string;
    label: string;
    login?: boolean;
    value?: string;
}

export default function TextArea({
    className,
    name,
    label,
    value,
    ...otherProps
}: IProps) {
    const [val, setVal] = useState(value);
    const handleInput = (evt: any) => {
        setVal(evt.target.value);
    };

    return (
        <div className={`input-field2 ${className || ''} `}>
            <textarea
                className={`${val ? 'filled' : ''}`}
                required
                autoComplete="off"
                onChange={handleInput}
                name={name}
                value={value}
                {...otherProps}
            />
            <label htmlFor={name}>{label}</label>
        </div>
    );
}
